export default __webpack_public_path__ + "static/media/Warmonger's Dagger.f0696365.jpg";